import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ActionLibraryPage } from '../../../features/task-actions/LibraryPage';

export const Route = createFileRoute('/_settings/settings/action-library')({
  validateSearch: (search: Record<string, unknown>): { action?: string } => ({
    ...(typeof search.action === 'string' ? { action: search.action } : {}),
  }),
  component: ActionLibraryRoute,
});

function ActionLibraryRoute() {
  const { action } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ActionLibraryPage
      selected={action}
      onSelect={(key) => void navigate({ search: key ? { action: key } : {}, replace: true })}
    />
  );
}
